import { Injectable } from "@angular/core";
import { UdfContext, UserDefinedFieldViewModel } from "@tylertech/tyler-api-types";

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { UserDefinedFieldsDialogComponent, UserDefinedFieldsDialogData } from "../components";

@Injectable()
export class UserDefinedFieldsDialogsService
{
    constructor(private readonly matDialog: MatDialog) { }

    show(
        settings: UdfContext,
        viewOnly: boolean,
        userDefinedFields?: Array<UserDefinedFieldViewModel>
    ): Promise<Array<UserDefinedFieldViewModel> | undefined>
    {
        const dialogConfig: MatDialogConfig<UserDefinedFieldsDialogData> = {
            data: {
                settings,
                userDefinedFields,
                viewOnly
            }
        };
        const dialogRef = this.matDialog.open(UserDefinedFieldsDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();
    }
}
